"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppBarRightContent = exports.StyledAppBarLeftContent = exports.StyledAppBarContent = exports.StyledAppBarInner = exports.StyledAppBar = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledAppBar = styled_components_1.default.header({
    boxSizing: 'border-box',
    color: theme_1.colors.white,
    left: '0px',
    padding: "0px " + theme_1.scaffolding.md,
    right: '0px',
    top: '0px',
    width: '100%',
    zIndex: theme_1.depths.appBar,
}, function (_a) {
    var _b;
    var position = _a.position, padding = _a.padding, backgroundColor = _a.backgroundColor;
    return (_b = {
            backgroundColor: backgroundColor || theme_1.colors.black,
            position: position
        },
        _b[theme_1.mediaQuery(theme_1.breakpoints.md)] = {
            padding: "0px " + (padding ? padding.md : '40px'),
        },
        _b);
});
exports.StyledAppBarInner = styled_components_1.default.div({
    display: 'flex',
    flexDirection: 'row',
    margin: '0px auto',
    width: '100%',
}, function (_a) {
    var isFluid = _a.isFluid;
    return ({
        maxWidth: isFluid ? '100%' : theme_1.breakpoints.xxl,
    });
});
var commonStyles = {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    minHeight: theme_1.scaffolding.xxl,
    position: 'relative',
};
var getThinSettings = function (thin) {
    var _a;
    return thin
        ? typeof thin === 'object'
            ? (_a = {
                    minHeight: theme_1.scaffolding.xxl
                },
                _a[theme_1.mediaQueryBetween((thin.min || theme_1.breakpoints.md), (thin.max || theme_1.breakpoints.lg))] = {
                    minHeight: theme_1.scaffolding.xl,
                    paddingBottom: theme_1.scaffolding.sm,
                    paddingTop: theme_1.scaffolding.sm,
                },
                _a) : {
            minHeight: theme_1.scaffolding.xl,
            paddingBottom: theme_1.scaffolding.sm,
            paddingTop: theme_1.scaffolding.sm,
        }
        : {
            minHeight: theme_1.scaffolding.xxl,
        };
};
exports.StyledAppBarContent = styled_components_1.default.div(__assign({ width: '100%' }, commonStyles), function (_a) {
    var thin = _a.thin;
    return getThinSettings(thin);
});
exports.StyledAppBarLeftContent = styled_components_1.default.div(__assign(__assign({}, commonStyles), { flexBasis: '100%', justifyContent: 'flex-start' }), function (_a) {
    var thin = _a.thin;
    return getThinSettings(thin);
});
exports.StyledAppBarRightContent = styled_components_1.default.div(__assign(__assign({}, commonStyles), { flexBasis: '100%', justifyContent: 'flex-end' }), function (_a) {
    var thin = _a.thin;
    return getThinSettings(thin);
});
//# sourceMappingURL=styles.js.map